var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_1799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.400024 1.90625V47.0938H48.4V1.90625H0.400024ZM45.5875 4.71875V10.4375H3.21252V4.71875H45.5875ZM25.8063 21.6875H34.2438V27.3125H25.8063V21.6875ZM22.9938 27.3125H14.5563V21.6875H22.9938V27.3125ZM25.8063 18.875V13.25H34.2438V18.875H25.8063ZM22.9938 18.875H14.5563V13.25H22.9938V18.875ZM11.7438 18.875H3.21252V13.25H11.7438V18.875ZM11.7438 21.6875V27.3125H3.21252V21.6875H11.7438ZM11.7438 30.125V35.75H3.21252V30.125H11.7438ZM14.5563 30.125H22.9938V35.75H14.5563V30.125ZM22.9938 38.5625V44.2812H14.5563V38.5625H22.9938ZM25.8063 38.5625H34.2438V44.2812H25.8063V38.5625ZM25.8063 35.75V30.125H34.2438V35.75H25.8063ZM37.0563 30.125H45.5875V35.75H37.0563V30.125ZM37.0563 27.3125V21.6875H45.5875V27.3125H37.0563ZM37.0563 18.875V13.25H45.5875V18.875H37.0563ZM3.21252 38.5625H11.7438V44.2812H3.21252V38.5625ZM37.0563 44.2812V38.5625H45.5875V44.2812H37.0563Z",
    fill: "#19A69D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_1799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.400024 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.e492eb4cb7908704cc8ab2527466c7dc.svg";
export { ForwardRef as ReactComponent };